import { Button, FormField, Header, Input, Link, List, Popover, SelectProps, SpaceBetween, SplitPanel, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useState } from 'react';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiAccountOutline, mdiRefresh, mdiSwapVertical, mdiTrophyOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { buildBreadcrumbItems, getCookie, getParameter, getUrlVersion, setLoading } from '../../../../commons/functions';

import { addDays, format } from 'date-fns';
import React from 'react';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemDirector, ItemShift } from '../../../../../resources/types';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const pageSize = 20;
type OptionDefinition = SelectProps.Option;

export const OPSMercenariesShiftsPage = () => {
    const { menu, parameters } = useGlobalState();
    const [isSplitPanelOpen, setIsSplitPanelOpen] = useState(false);

    const [targetIdUser, setTargetIdUser] = useState(0);
    const [targetShift, setTargetShift] = useState('');

    //const [filteredShifts, setFilteredShifts] = useState<ItemShift[]>([]);
    const [keyw, setKeyw] = useState<string>("");

    //const storeAdmin = useStoreAdmin();



    const [usersTows, setUsersTows] = useState<ItemDirector[]>([]);
    const [usersDirectors, setUsersDirectors] = useState<ItemDirector[]>([]);
    const [shifts, setShifts] = useState<ItemShift[]>([]);
    const [shift, setShift] = useState<ItemShift>();
    const [selectedTarget, setSelectedTarget] = useState<OptionDefinition | null>(null);

    const [filteringText, setFilteringText] = useState('');
    const [sortingColumn, setSortingColumn] = useState({
        sortingField: 'registration',
        isDescending: false,
    });

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    //const [loading, setLoading] = useState<boolean>(true);

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [init, setInit] = useState(false);


    const expa = [true, false, false];
    const returnURL = getParameter(window.location.hash, 'returnURL');

    useEffect(() => {
        if (init) {
            (returnURL && returnURL === '' ? window.location.hash = '#home' : window.location.hash = returnURL);

        };

    }, [init]);
    useEffect(() => {
        handleRefresh()
    }, [parameters]);
    const handleExchange = async () => {
        let body = {
            idShift: shift?.idShift,
            shift: targetShift,
            idUser: targetIdUser,
        }
    }

    const handleRefresh = async () => {
        try {
            setLoading(true);

            let body: any = {
                start: format(addDays(new Date(), -90), 'dd-MM-yyyy'),
                isSelling: "",
                orderBy: "dateShift",
                order: "desc",
                //columns: "idUser, idUserTowing1, idUserTowing2, idUserDirectorOld, userDirector, userTow1, userTow2, userDirectorOld, userMercenary, idShift, hashShift, dateShift, isSelling, isClosed, isPaid, dateStartSelling, idMercenaryUser, jsonShift, jsonMercenaries"
            }

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data.code === 0) {
                setShifts(data.shifts)
            } else {

            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleRefresh();
    }, []);


    const filteredShifts = keyw.length >= 3
        ? shifts
            .filter(shift => {
                const searchWords = keyw.toLowerCase().split(/\s+/).filter(Boolean);
                return searchWords.every(word =>
                    shift.dateShift.toLowerCase().includes(word) ||
                    shift.user.toLowerCase().includes(word) ||
                    shift.userMercenary.toLowerCase().includes(word)
                );
            })
        : shifts;

    const mercenaries = shift?.jsonExchange;
    return (
        <CustomAppLayout
            toolsHide={true}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            splitPanelOpen={isSplitPanelOpen}
            onSplitPanelToggle={({ detail }) => setIsSplitPanelOpen(detail.open)}

            splitPanel={
                <SplitPanel hidePreferencesButton header={`Turno #${shift?.idShift}`} closeBehavior='hide'
                >
                    <SpaceBetween direction='vertical' size='xs'>



                    </SpaceBetween>
                </SplitPanel >
            }
            content={
                < SpaceBetween size="xs" >
                    <Header actions={


                        <SpaceBetween direction="horizontal" size="xs">
                            <Favorites />
                        </SpaceBetween>
                    }>
                        Turnos { }

                    </Header>
                    <Table

                        stripedRows
                        stickyHeader
                        variant='embedded'
                        filter={
                            <SpaceBetween direction='horizontal' size='xs'>
                                <Input value={keyw} placeholder='Filtar' onChange={({ detail }) => {
                                    setKeyw(detail.value);
                                }} />
                                <Button
                                    key={"btnDate"}
                                    variant='primary'
                                    style={{ root: btnIconForm }}
                                    onClick={() => {
                                        if (parameters.date !== "") {
                                            setCurrentPageIndex(1);
                                            handleRefresh();
                                        }
                                    }}
                                ><Icon path={mdiRefresh} size={1} /></Button>
                            </SpaceBetween>
                        }
                        columnDefinitions={[
                            {
                                id: "idShift",
                                header: "ID/Fecha",
                                width: 120,
                                cell: (item) =>


                                    <FormField
                                        label={
                                            <Link onClick={() => {
                                                window.location.hash = `ops/mercenaries/shifts?idShift=${item.idShift}`;
                                            }} >{item.idShift}</Link>}
                                    >{item.dateShift}</FormField>

                            },
                            {
                                id: "dateShift",
                                header: "Estado",
                                width: 120,
                                cell: (item) => (
                                    item.isSelling == 1 ?
                                        <BadgeCustom color="violet" >En venta</BadgeCustom>
                                        : item.isSelling == 2 ?
                                            <BadgeCustom color='blue'>Vendido</BadgeCustom> : null

                                )
                            },
                            {
                                id: "userDirector",
                                header: "Director",
                                cell: (item) => (
                                    <FormField
                                        description={
                                            item.userMercenary != ""
                                                ? <>
                                                    <Icon path={mdiSwapVertical} size={1} /> {item.user}
                                                </>
                                                : null
                                        }
                                        label={item.userMercenary !== "" ? `${item.userMercenary}` : item.user}
                                    />
                                )

                                //sortingField: "displayName",
                            },
                            {
                                id: "mercenaries",
                                header: "Mercenarios",
                                cell: (item) => !item.jsonExchange || item.jsonExchange.length === 0 ? '---' : (

                                    <Popover dismissButton={false} triggerType="custom"
                                        header="Postulantes"
                                        content={
                                            <List
                                                ariaLabel="Lista de mercenarios"
                                                items={item?.jsonExchange?.map((m: any) => ({
                                                    id: String(m.idUser),
                                                    content: m.idUser !== item.idUserMercenary ? `${m.displayName}` : <SpaceBetween size='xs' direction='horizontal'><Icon path={mdiTrophyOutline} size={0.75} />{m.displayName}</SpaceBetween>
                                                }))}
                                                renderItem={(merc) => merc}
                                            />
                                        }
                                    >
                                        <Icon path={mdiAccountOutline} size={1} />x{item.jsonExchange.length}
                                    </Popover>)
                            },
                        ]}
                        items={filteredShifts}
                        selectionType={undefined}
                        trackBy="idShift"
                    />

                </SpaceBetween >
            }
        />

    );
};
